const SideContainer = (props) => {
  return (
    <div className="max-lg:hidden w-full lg:w-72 min-w-[16rem] border-r-[0.5px] border-black border-solid h-full overflow-y-auto px-4">
      {props.children}
    </div>
  )
}
export default SideContainer;